import { runInAction } from "mobx";
import AppStore from "./AppStore";
import Store from "./Store";
import TrainingRequest, { ITrainingRequest } from "../models/TrainingRequestModel";

export default class TrainingRequestStore extends Store<ITrainingRequest, TrainingRequest> {
    items = new Map<string, TrainingRequest>();

    constructor(store: AppStore) {
        super(store);
        this.store = store;
    }

    load(items: ITrainingRequest[] = []) {
        runInAction(() => {
            items.forEach((item) => {
                this.items.set(item.id, new TrainingRequest(this.store, item))
            })
        });
    }
}
